export default "__VITE_ASSET__ytY3fKH2__"